import "./admin-assets.47ee0bd4.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire588a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire588a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;


var $crOjV = parcelRequire("crOjV");
document.addEventListener('DOMContentLoaded', function() {
    const backUp = document.getElementById('backUp');
    window.addEventListener('scroll', ()=>{
        if (window.scrollY > window.innerHeight * 0.8) backUp.style.display = 'flex';
        else backUp.style.display = 'none';
    });
    backUp.addEventListener('click', ()=>{
        window.scrollTo({
            behavior: 'smooth',
            top: 0
        });
    });
    document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
    (0, $crOjV.initGallery)();
});


//# sourceMappingURL=assets.f119253b.js.map
